export const operators = [
  { value: "eq", label: "=" },
  { value: "gt", label: ">" },
  { value: "ge", label: ">=" },
  { value: "lt", label: "<" },
  { value: "le", label: "<=" },
]

export const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"

export const comparisonRegExpStr =
  "([a-zA-Z0-9_ .-]*)(=|<=|>=|>|<)([a-zA-Z0-9_ .-]*)"
export const comparisonRegExp = new RegExp(comparisonRegExpStr, "i")
export const comparisonShortFormRegExp = new RegExp(
  "(=|<=|>=|>|<)([a-zA-Z0-9_ .-]*)",
  "i"
)
export const comparisonFormulaRegExp = new RegExp(
  `^(=)${comparisonRegExpStr}`,
  "i"
)
export const comparisonFormulaAsConditionRegExp = new RegExp(
  `^(=IF\\(${comparisonRegExpStr}\\)$)`,
  "i"
)
const logicRegExpStr = "(AND|OR)(\\(.*\\))"
export const nestedLogicRegExp = new RegExp(logicRegExpStr, "i")
export const logicRegExp = new RegExp(`^(=)${logicRegExpStr}`, "i")

export const edgeSourceSheetHandleRegExp = new RegExp(
  "source-sheet-(.*)-row-(.*)"
)

export const edgeTargetSheetHandleRegExp = new RegExp(
  ".*target-sheet-(.*)-row-(\\d*).*"
)

export const SHORT_CELL_WIDTH = 150
export const CELL_WIDTH = 225
export const ROW_INDEX_WIDTH = 33

export const CANVAS_SIZE = 10000

export const MULTIPLAYER_USER_COLORS = [
  "#4b91ec",
  "#ca84e2",
  "#ff7cb1",
  "#ffc547",
  "#2ECC71",
  "#e7364b",
  "#00aff0",
  "#D4A4FF",
]
